/**
 * Rich sample data for the 'Minimal Catalog' template.
 * Tailored for hardware, industrial tools, fasteners, valves, and electrical distributors.
 */

export const minimalCatalogSample = {
  company: {
    id: "sample-bharat-tools",
    name: "Bharat Industrial Tools & Fasteners",
    tagline: "Quality Industrial Fasteners & Workshop Tooling at Scale",
    description: "Leading manufacturer and bulk stockist of high-tensile industrial fasteners, stainless steel hex bolts, carbide end-mills, and workshop pneumatic tools. 100% test-certified dispatches with same-day dispatch commitment.",
    location: "Peenya Industrial Area, Bengaluru, Karnataka",
    city: "Bengaluru",
    state: "Karnataka",
    address: "Shop 14-16, Industrial Commercial Complex, 1st Stage, Peenya, Bengaluru 560058",
    pincode: "560058",
    logo_url: "https://images.unsplash.com/photo-1581092160607-ee22621dd758?w=200&h=200&fit=crop&q=80",
    cover_url: "https://images.unsplash.com/photo-1581092335397-9583fe92d232?w=1600&q=80",
    category: "Tools & Fasteners",
    mobile: "+91 97410 33445",
    whatsapp: "+91 97410 33445",
    email: "orders@bharatfasteners.in",
    website: "https://bharattools.indianindustrialplatform.com",
    gst: "29AALCB9012K1Z4",
    pan: "AALCB9012K",
    business_type: "Wholesaler & Stockist",
    year_established: 2012,
    employees: "40 - 60 Team Members",
    certifications: ["ISO 9001:2015", "DIN / ISO Fastener Standards", "BIS Certified Fasteners"],
    is_featured: true,
  },
  stats: [
    { label: "Catalog Active SKUs", value: "14,500+" },
    { label: "Dispatch SLA", value: "Same Day" },
    { label: "Verified Buyer Network", value: "4,200+" },
    { label: "Pan-India Pin Codes", value: "18,000+" },
  ],
  products: [
    {
      id: "prod-201",
      name: "High Tensile Grade 10.9 Hex Head Fasteners (M12 - M36)",
      category: "Industrial Fasteners",
      image_url: "https://images.unsplash.com/photo-1581092160607-ee22621dd758?w=800&q=80",
      images: [
        "https://images.unsplash.com/photo-1581092160607-ee22621dd758?w=800&q=80"
      ],
      price: "₹48 / Pc",
      moq: "500 Pieces",
      description: "Forged alloy steel quenched & tempered hex bolts according to DIN 931. Black phosphate coated for high shear stress industrial structural assemblies.",
      stock_left: 5000,
      location: "Bengaluru, Karnataka"
    },
    {
      id: "prod-202",
      name: "Solid Micrograin Carbide 4-Flute End Mill Cutters",
      category: "Cutting Tools",
      image_url: "https://images.unsplash.com/photo-1504917599217-d4dc5ebe6122?w=800&q=80",
      images: [
        "https://images.unsplash.com/photo-1504917599217-d4dc5ebe6122?w=800&q=80"
      ],
      price: "₹1,450 / Pc",
      moq: "10 Pieces",
      description: "AlTiN nano-coated micrograin carbide end-mills designed for high-efficiency slotting and profiling in steel up to 55 HRC.",
      stock_left: 350,
      location: "Bengaluru, Karnataka"
    },
    {
      id: "prod-203",
      name: "Stainless Steel 316 3-Piece Flanged Ball Valve 2-Inch",
      category: "Valves & Flow Control",
      image_url: "https://images.unsplash.com/photo-1581092335397-9583fe92d232?w=800&q=80",
      images: [
        "https://images.unsplash.com/photo-1581092335397-9583fe92d232?w=800&q=80"
      ],
      price: "₹3,850",
      moq: "5 Units",
      description: "Full bore ASTM A351 CF8M stainless steel ball valve with PTFE seals, 1000 WOG rating, suitable for chemical and water pipelines.",
      stock_left: 80,
      location: "Bengaluru, Karnataka"
    },
    {
      id: "prod-204",
      name: "1/2-Inch Heavy Duty Pneumatic Twin-Hammer Air Wrench",
      category: "Workshop Power Tools",
      image_url: "https://images.unsplash.com/photo-1563986768609-322da13575f3?w=800&q=80",
      images: [
        "https://images.unsplash.com/photo-1563986768609-322da13575f3?w=800&q=80"
      ],
      price: "₹6,900",
      moq: "2 Units",
      description: "Professional garage and assembly pneumatic impact wrench delivering 900 Nm max torque with composite lightweight housing.",
      stock_left: 45,
      location: "Bengaluru, Karnataka"
    }
  ],
  posts: [
    {
      id: "post-201",
      content: "Fresh shipment of Grade 8.8 and 10.9 hot-dip galvanized fasteners arrived at our central warehouse. Bulk discounts available for order lots above 50,000 units.",
      media_url: "https://images.unsplash.com/photo-1581092160607-ee22621dd758?w=800&q=80",
      media_urls: ["https://images.unsplash.com/photo-1581092160607-ee22621dd758?w=800&q=80"],
      media_type: "image",
      category: "Stock Inventory",
      created_at: "2026-10-14T08:30:00Z"
    }
  ],
  reels: []
};
